import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_MERCHANTS,
    ADD_NEW_MERCHANT,
    GET_MERCHANT_DETAIL,
    GET_MERCHANT_COMMUNICATIONS,
    MANAGE_MERCHANT_COMMUNICATION,
    GET_MERCHANT_CONTACTS,
    MANAGE_MERCHANT_CONTACT,
    GET_MERCHANT_CONTACT_COMMUNICATIONS,
    MANAGE_MERCHANT_CONTACT_COMMUNICATION,
    GET_MERCHANT_BANKING_DETAIL,
    ADD_NEW_MERCHANT_BANKING,
    DELETE_MERCHANT,
    MANAGE_MERCHANT_BANKING,
    TOGGLE_MERCHANT_BANKING_DEFAULT,
    CHECK_MERCHANT_BANKING_STATUS,
    GET_MERCHANT_IMAGES,
    MANAGE_MERCHANT_IMAGE,
    GET_MERCHANT_TIMINGS,
    MANAGE_MERCHANT_TIMING,
    GET_MERCHANT_ATTRIBUTES,
    MANAGE_MERCHANT_ATTRIBUTE,
    GET_MERCHANT_TAGS,
    MANAGE_MERCHANT_TAG,
    GET_TAG_DEFINITIONS,
    GET_MERCHANT_VARIABLES,
    CREATE_MERCHANT_VARIABLES,
    UPDATE_MERCHANT_VARIABLES,
    GET_RECONCILIATION_FREQUENCIES,
    REORDER_MERCHANT_IMAGES,
    GET_MERCHANT_PINS,
    SHOW_MERCHANT_PINS,
    UPDATE_MERCHANT_PINS,
} from "./actionTypes"

import {
    getMerchantsSuccess,
    getMerchantsFail,
    addNewMerchantSuccess,
    addNewMerchantFail,
    getMerchantDetailSuccess,
    getMerchantDetailFail,
    getMerchantCommunicationsSuccess,
    getMerchantCommunicationsFail,
    manageMerchantCommunicationSuccess,
    manageMerchantCommunicationFail,
    getMerchantContactsSuccess,
    getMerchantContactsFail,
    manageMerchantContactSuccess,
    manageMerchantContactFail,
    getMerchantContactCommunicationsSuccess,
    getMerchantContactCommunicationsFail,
    manageMerchantContactCommunicationSuccess,
    manageMerchantContactCommunicationFail,
    getMerchantBankingDetailSuccess,
    getMerchantBankingDetailFail,
    addNewMerchantBankingSuccess,
    addNewMerchantBankingFail,
    getMerchantCommunications,
    getMerchantContacts,
    getMerchantContactCommunications as getMerchantContactCommunicationsAction,
    deleteMerchantSuccess,
    deleteMerchantFail,
    manageMerchantBankingSuccess,
    manageMerchantBankingFail,
    toggleMerchantBankingDefaultSuccess,
    toggleMerchantBankingDefaultFail,
    checkMerchantBankingStatusSuccess,
    checkMerchantBankingStatusFail,
    getMerchantBankingDetail,
    getMerchantImagesSuccess,
    getMerchantImagesFail,
    manageMerchantImageSuccess,
    manageMerchantImageFail,
    getMerchantImages,
    getMerchantTimingsSuccess,
    getMerchantTimingsFail,
    manageMerchantTimingSuccess,
    manageMerchantTimingFail,
    getMerchantTimings as getMerchantTimingsAction,
    getMerchantAttributesSuccess,
    getMerchantAttributesFail,
    manageMerchantAttributeSuccess,
    manageMerchantAttributeFail,
    getMerchantAttributes,
    getMerchantTags,
    getMerchantTagsSuccess,
    getMerchantTagsFail,
    manageMerchantTagSuccess,
    manageMerchantTagFail,
    getTagDefinitionsSuccess,
    getTagDefinitionsFail,
    getMerchantVariablesSuccess,
    getMerchantVariablesFail,
    createMerchantVariablesSuccess,
    createMerchantVariablesFail,
    updateMerchantVariablesSuccess,
    updateMerchantVariablesFail,
    getReconciliationFrequenciesSuccess,
    getReconciliationFrequenciesFail,
    reorderMerchantImagesSuccess,
    reorderMerchantImagesFail,
    getMerchantPinsSuccess,
    getMerchantPinsFail,
    showMerchantPinsSuccess,
    showMerchantPinsFail,
    updateMerchantPinsSuccess,
    updateMerchantPinsFail,
} from "./actions"
import {
    getMerchants,
    addNewMerchant,
    getMerchantDetail,
    getMerchantCommunications as getMerchantCommunicationsAPI,
    manageMerchantCommunication,
    getMerchantContacts as getMerchantContactsAPI,
    manageMerchantContact,
    getMerchantContactCommunications,
    manageMerchantContactCommunication,
    getMerchantBankingDetail as getMerchantBankingDetailAPI,
    getMerchantAttributes as getMerchantAttributesAPI,
    manageMerchantAttribute,
    addNewMerchantBanking,
    toggleMerchantBankingStatus,
    toggleMerchantBankingDefault,
    checkMerchantBankingStatus as checkMerchantBankingStatusAPI,
    uploadBase64File,
    getMerchantImages as getMerchantImagesAPI,
    manageMerchantImage,
    getMerchantTimings as getMerchantTimingsAPI,
    manageMerchantTiming,
    getMerchantTags as getMerchantTagsAPI,
    manageMerchantTag,
    getTagDefinitions as getTagDefinitionsAPI,
    getMerchantVariables as getMerchantVariablesAPI,
    createMerchantVariables as createMerchantVariablesAPI,
    updateMerchantVariables as updateMerchantVariablesAPI,
    getReconciliationFrequencies as getReconciliationFrequenciesAPI,
    reorderMerchantImages as reorderMerchantImagesAPI,
    getMerchantPins as getMerchantPinsAPI,
    showMerchantPins as showMerchantPinsAPI,
    updateMerchantPins as updateMerchantPinsAPI
} from "../../helpers/backend_helper"

function* fetchMerchants({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchants, options)

        yield put(getMerchantsSuccess(response))
    } catch (error) {
        yield put(getMerchantsFail(error))
    }
}

function* onAddNewMerchant({ payload: { data, options, history } }) {
    try {
        const response = yield call(addNewMerchant, data, options)
        yield put(addNewMerchantSuccess(response))
    } catch (error) {
        yield put(addNewMerchantFail(error))
    }
}

function* fetchMerchantDetail({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantDetail, options)
        yield put(getMerchantDetailSuccess(response))
    } catch (error) {
        yield put(getMerchantDetailFail(error))
    }
}

function* fetchMerchantCommunications({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantCommunicationsAPI, options)
        yield put(getMerchantCommunicationsSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantCommunicationsSuccess([]))
        } else {
            yield put(getMerchantCommunicationsFail(error))
        }
    }
}

function* onManageMerchantCommunication({
    payload: { data, options, history },
}) {
    try {
        const response = yield call(manageMerchantCommunication, data, options)
        yield put(manageMerchantCommunicationSuccess(response))

        // Refresh communications list
        yield put(
            getMerchantCommunications({
                headers: {
                    "input-parameters": { merchantID: data.merchantID },
                },
            })
        )
    } catch (error) {
        yield put(manageMerchantCommunicationFail(error))
    }
}

function* fetchMerchantContacts({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantContactsAPI, options)
        yield put(getMerchantContactsSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantContactsSuccess([]))
        } else {
            yield put(getMerchantContactsFail(error))
        }
    }
}

function* onManageMerchantContact({ payload: { data, options, history } }) {
    try {
        // If there's a photo to upload, handle it first
        let finalData = { ...data }

        if (data.photo && data.photo.base64encodedFileByteArray) {
            try {
                const uploadResponse = yield call(uploadBase64File, data.photo, options)
                if (uploadResponse && uploadResponse.fileName) {
                    finalData.photo = uploadResponse.fileName
                } else {
                    throw new Error("Failed to upload photo")
                }
            } catch (uploadError) {
                yield put(
                    manageMerchantContactFail({
                        message: "Failed to upload photo. Please try again.",
                    })
                )
                return
            }
        } else if (!data.photo || data.photo === "") {
            finalData.photo = ""
        }

        const response = yield call(manageMerchantContact, finalData, options)
        yield put(manageMerchantContactSuccess(response))

        // Refresh contacts list
        yield put(
            getMerchantContacts({
                headers: {
                    "input-parameters": { merchantID: data.merchantID },
                },
            })
        )
    } catch (error) {
        yield put(manageMerchantContactFail(error))
    }
}

function* fetchMerchantContactCommunications({
    payload: { options, history },
}) {
    try {
        const response = yield call(getMerchantContactCommunications, options)
        yield put(getMerchantContactCommunicationsSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantContactCommunicationsSuccess([]))
        } else {
            yield put(getMerchantContactCommunicationsFail(error))
        }
    }
}

function* onManageMerchantContactCommunication({
    payload: { data, options, history },
}) {
    try {
        const response = yield call(
            manageMerchantContactCommunication,
            data,
            options
        )
        yield put(manageMerchantContactCommunicationSuccess(response))

        // Refresh the contact communications list
        if (data.merchantContactID) {
            yield put(
                getMerchantContactCommunicationsAction({
                    headers: {
                        "input-parameters": { mContactID: data.merchantContactID },
                    },
                })
            )
        }
    } catch (error) {
        yield put(manageMerchantContactCommunicationFail(error))
    }
}

function* fetchMerchantBankingDetail({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantBankingDetailAPI, options)
        yield put(getMerchantBankingDetailSuccess(response))
    } catch (error) {
        yield put(getMerchantBankingDetailFail(error))
    }
}

function* onAddNewMerchantBanking({ payload: { data, options, history } }) {
    try {
        const response = yield call(addNewMerchantBanking, data, options)
        yield put(addNewMerchantBankingSuccess(response))

        // Refresh banking list after successful creation
        if (data.merchantID) {
            yield put(
                getMerchantBankingDetail({
                    headers: {
                        "input-parameters": { merchantID: data.merchantID },
                    }
                })
            )
        }
    } catch (error) {
        yield put(addNewMerchantBankingFail(error))
    }
}

function* onManageMerchantBanking({ payload: { data, options, history } }) {
    try {
        let response
        
        // Check if this is a toggle operation (activate/deactivate)
        if (data.actionType === "activate" || data.actionType === "deactivate") {
            // Use new toggle API with simplified payload
            const togglePayload = {
                actionType: data.actionType,
                merchantBankingID: data.merchantBankingID
            }
            response = yield call(toggleMerchantBankingStatus, togglePayload, options)
        } else {
            // Use existing manage API for other operations
            response = yield call(addNewMerchantBanking, data, options)
        }
        
        yield put(manageMerchantBankingSuccess(response))
        // Refresh banking list after successful operation (activate/deactivate)

        if (response.merchantID || data.merchantID) {
            // yield delay(1000)
            yield put(
                getMerchantBankingDetail({
                    headers: {
                        "input-parameters": { merchantID: response.merchantID || data.merchantID },
                    }
                })
            )
        }

    } catch (error) {
        yield put(manageMerchantBankingFail(error))
    }
}

// Toggle Merchant Banking Default Saga
function* toggleMerchantBankingDefaultSaga({ payload: { data, options, history } }) {
    try {
        const response = yield call(toggleMerchantBankingDefault, data, options)
        yield put(toggleMerchantBankingDefaultSuccess(response))

        // Refresh banking list after successful operation
        if (response.merchantID || data.merchantID) {
            yield put(
                getMerchantBankingDetail({
                    headers: {
                        "input-parameters": { merchantID: response.merchantID || data.merchantID },
                    }
                })
            )
        }
    } catch (error) {
        yield put(toggleMerchantBankingDefaultFail(error))
    }
}

// Check Merchant Banking Status Saga
function* checkMerchantBankingStatusSaga({ payload: { destinationID } }) {
    try {
        const response = yield call(checkMerchantBankingStatusAPI, destinationID, {})
        yield put(checkMerchantBankingStatusSuccess(response.destinationID, response.status))
    } catch (error) {
        yield put(checkMerchantBankingStatusFail(error))
    }
}

// Delete Merchant Saga
function* onDeleteMerchant({ payload: { data, options, history } }) {
    try {
        const response = yield call(addNewMerchant, data, options)
        yield put(deleteMerchantSuccess(response))

        // Refresh the merchants list using pagination from options
        const refreshPagination = options?.refreshPagination || {}
        try {
            const refreshResponse = yield call(getMerchants, {
                headers: {
                    "input-parameters": { keyword: refreshPagination.keyword || "" },
                },
                pagination: { startIndex: refreshPagination.startIndex ?? 0 },
            })
            yield put(getMerchantsSuccess(refreshResponse))
        } catch (refreshError) {
            if (refreshError.message === "No content available") {
                yield put(getMerchantsSuccess([]))
            } else {
                yield put(getMerchantsFail(refreshError))
            }
        }
    } catch (error) {
        yield put(deleteMerchantFail(error))
    }
}

// Merchant Timings Sagas
function* fetchMerchantTimings({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantTimingsAPI, options)
        yield put(getMerchantTimingsSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantTimingsSuccess([]))
        } else {
            yield put(getMerchantTimingsFail(error))
        }
    }
}
function* fetchMerchantAttributes({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantAttributesAPI, options)
        yield put(getMerchantAttributesSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantAttributesSuccess([]))
        } else {
            yield put(getMerchantAttributesFail(error))
        }
    }
}

function* onManageMerchantTiming({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantTiming, data, options)
        yield put(manageMerchantTimingSuccess(response))

        // Refresh timings list after successful operation
        if (data.merchantID) {
            yield put(
                getMerchantTimingsAction({
                    headers: {
                        "input-parameters": { merchantID: data.merchantID },
                    }
                })
            )
        }
    } catch (error) {
        yield put(manageMerchantTimingFail(error))
    }
}
function* onManageMerchantAttribute({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantAttribute, data, options)
        yield put(manageMerchantAttributeSuccess(response))

        // Refresh attributes list after successful operation
        yield put(
            getMerchantAttributes({
                headers: {
                    "input-parameters": { merchantID: data.merchantID },
                },
            })
        )
    } catch (error) {
        yield put(manageMerchantAttributeFail(error))
    }
}

function* fetchMerchantImages({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantImagesAPI, options)
        yield put(getMerchantImagesSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantImagesSuccess([]))
        } else {
            yield put(getMerchantImagesFail(error))
        }
    }
}

function* onManageMerchantImage({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantImage, data, options)
        yield put(manageMerchantImageSuccess(response))

        // Refresh images list after successful operation
        yield put(
            getMerchantImages({
                headers: {
                    "input-parameters": { merchantID: data.merchantID },
                },
            })
        )
    } catch (error) {
        yield put(manageMerchantImageFail(error))
    }
}

function* onReorderMerchantImages({ payload: { data, options, history } }) {
    try {
        const response = yield call(reorderMerchantImagesAPI, data, options)
        yield put(reorderMerchantImagesSuccess(response))

        yield put(
            getMerchantImages({
                headers: {
                    "input-parameters": { merchantID: data.merchantID },
                },
            })
        )
    } catch (error) {
        console.error("Error reordering merchant images:", error)
        yield put(reorderMerchantImagesFail(error))
    }
}

// Merchant Tags Sagas
function* fetchMerchantTags({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantTagsAPI, options)
        yield put(getMerchantTagsSuccess(response))
    } catch (error) {
        yield put(getMerchantTagsFail(error))
    }
}

function* onManageMerchantTag({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantTag, data, options)
        yield put(manageMerchantTagSuccess(response))

        yield put(getMerchantTags({
            headers: {
                "input-parameters": { merchantID: data.merchantID },
            },
        }))

    } catch (error) {
        yield put(manageMerchantTagFail(error))
    }
}

// Tag Definitions Sagas
function* fetchTagDefinitions({ payload: { options, history } }) {
    try {
        const response = yield call(getTagDefinitionsAPI, options)
        yield put(getTagDefinitionsSuccess(response))
    } catch (error) {
        yield put(getTagDefinitionsFail(error))
    }
}
function* fetchMerchantVariables({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantVariablesAPI, options)
        yield put(getMerchantVariablesSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantVariablesSuccess(null))
        } else {
            yield put(getMerchantVariablesFail(error))
        }
    }
}

function* onCreateMerchantVariables({ payload: { data, options, history } }) {
    try {
        const response = yield call(createMerchantVariablesAPI, data, options)
        yield put(createMerchantVariablesSuccess(response))
    } catch (error) {
        yield put(createMerchantVariablesFail(error))
    }
}

function* onUpdateMerchantVariables({ payload: { data, options, history } }) {
    try {
        const response = yield call(updateMerchantVariablesAPI, data, options)
        yield put(updateMerchantVariablesSuccess(response))
    } catch (error) {
        yield put(updateMerchantVariablesFail(error))
    }
}

function* fetchReconciliationFrequencies() {
    try {
        const response = yield call(getReconciliationFrequenciesAPI)
        yield put(getReconciliationFrequenciesSuccess(response))
    } catch (error) {
        yield put(getReconciliationFrequenciesFail(error))
    }
}

function* fetchMerchantPins({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantPinsAPI, options)
        yield put(getMerchantPinsSuccess(response))
    } catch (error) {
        yield put(getMerchantPinsFail(error))
    }
}

function* onShowMerchantPins({ payload: { options, history } }) {
    try {
        const response = yield call(showMerchantPinsAPI, options)
        yield put(showMerchantPinsSuccess(response))
    } catch (error) {
        yield put(showMerchantPinsFail(error))
    }
}

function* onUpdateMerchantPins({ payload: { data, options, history } }) {
    try {
        const response = yield call(updateMerchantPinsAPI, data, options)
        yield put(updateMerchantPinsSuccess(response))
    } catch (error) {
        yield put(updateMerchantPinsFail(error))
    }
}

function* merchantsSaga() {
    yield takeEvery(GET_MERCHANTS, fetchMerchants)
    yield takeEvery(ADD_NEW_MERCHANT, onAddNewMerchant)
    yield takeEvery(GET_MERCHANT_DETAIL, fetchMerchantDetail)
    yield takeEvery(GET_MERCHANT_COMMUNICATIONS, fetchMerchantCommunications)
    yield takeEvery(MANAGE_MERCHANT_COMMUNICATION, onManageMerchantCommunication)
    yield takeEvery(GET_MERCHANT_CONTACTS, fetchMerchantContacts)
    yield takeEvery(MANAGE_MERCHANT_CONTACT, onManageMerchantContact)
    yield takeEvery(
        GET_MERCHANT_CONTACT_COMMUNICATIONS,
        fetchMerchantContactCommunications
    )
    yield takeEvery(
        MANAGE_MERCHANT_CONTACT_COMMUNICATION,
        onManageMerchantContactCommunication
    )
    yield takeEvery(GET_MERCHANT_BANKING_DETAIL, fetchMerchantBankingDetail)
    yield takeEvery(ADD_NEW_MERCHANT_BANKING, onAddNewMerchantBanking)
    yield takeEvery(MANAGE_MERCHANT_BANKING, onManageMerchantBanking)
    yield takeEvery(TOGGLE_MERCHANT_BANKING_DEFAULT, toggleMerchantBankingDefaultSaga)
    yield takeEvery(CHECK_MERCHANT_BANKING_STATUS, checkMerchantBankingStatusSaga)
    yield takeEvery(DELETE_MERCHANT, onDeleteMerchant)
    yield takeEvery(GET_MERCHANT_TIMINGS, fetchMerchantTimings)
    yield takeEvery(MANAGE_MERCHANT_TIMING, onManageMerchantTiming)
    yield takeEvery(GET_MERCHANT_ATTRIBUTES, fetchMerchantAttributes)
    yield takeEvery(MANAGE_MERCHANT_ATTRIBUTE, onManageMerchantAttribute)
    yield takeEvery(GET_MERCHANT_IMAGES, fetchMerchantImages)
    yield takeEvery(MANAGE_MERCHANT_IMAGE, onManageMerchantImage)
    yield takeEvery(GET_MERCHANT_TAGS, fetchMerchantTags)
    yield takeEvery(MANAGE_MERCHANT_TAG, onManageMerchantTag)
    yield takeEvery(GET_TAG_DEFINITIONS, fetchTagDefinitions)
    yield takeEvery(GET_MERCHANT_VARIABLES, fetchMerchantVariables)
    yield takeEvery(CREATE_MERCHANT_VARIABLES, onCreateMerchantVariables)
    yield takeEvery(UPDATE_MERCHANT_VARIABLES, onUpdateMerchantVariables)
    yield takeEvery(GET_RECONCILIATION_FREQUENCIES, fetchReconciliationFrequencies)
    yield takeEvery(REORDER_MERCHANT_IMAGES, onReorderMerchantImages)
    yield takeEvery(GET_MERCHANT_PINS, fetchMerchantPins)
    yield takeEvery(SHOW_MERCHANT_PINS, onShowMerchantPins)
    yield takeEvery(UPDATE_MERCHANT_PINS, onUpdateMerchantPins)
}

export default merchantsSaga